import { ReferralsActionTypes, ReferralState } from 'types';
import { Reducer } from 'redux';

const initialState: ReferralState = {
  loading: false,
  referralLoader: false,
  error: '',
  data: {
    referrals: undefined,
    referral: undefined,
    filters: undefined
  },
  reprocess: {
    isLoading: false,
    modalType: 'NONE',
    status: 'NONE',
    error: ''
  }
};

const reducer: Reducer<ReferralState> = (state = initialState, action: any) => {
  switch (action.type) {
    case ReferralsActionTypes.FETCH_REFERRAL_BYID: {
      const { data, reprocess } = state;
      const referral = data?.referral;
      state = {
        referralLoader: true,
        data: {
          ...data,
          referral
        },
        reprocess
      };

      return state;
    }
    case ReferralsActionTypes.FETCH_REFERRAL_BYID_SUCCESS: {
      const { data, reprocess } = state;
      state = {
        referralLoader: false,
        data: {
          ...data,
          referral: action.payload
        },
        reprocess
      };
      return state;
    }
    case ReferralsActionTypes.FETCH_REFERRAL_BYID_FAILURE: {
      return {
        ...state,
        referralLoader: false,
        error: action.payload
      };
    }

    case ReferralsActionTypes.FETCH_REFERRAL_HISTORY: {
      const { data, reprocess } = state;
      const { referrals } = data;
      state = {
        referralLoader: false,
        loading: referrals ? false : true,
        loader: referrals && true,
        data,
        reprocess
      };
      return state;
    }
    case ReferralsActionTypes.FETCH_REFERRAL_HISTORY_SUCCESS: {
      const { data, reprocess } = state;
      const count = action?.payload?.count;
      const newEnquiryList = action?.payload?.items;
      const filteredReferrals = {
        items: newEnquiryList,
        count,
        queryCreatedBefore: action?.payload?.queryCreatedBefore,
        queryCreatedAfter: action?.payload?.queryCreatedAfter
      };
      state = {
        data: {
          ...data,
          referrals: filteredReferrals
        },
        reprocess
      };
      return state;
    }
    case ReferralsActionTypes.FETCH_REFERRAL_HISTORY_FAILURE: {
      state = {
        ...initialState,
        error: action.payload
      };
      return state;
    }
    case ReferralsActionTypes.SET_REFERRAL_SEARCH_FILTER: {
      const { data } = state;
      state = {
        ...state,
        data: {
          ...data,
          filters: action.payload
        }
      };
      return state;
    }
    case ReferralsActionTypes.SET_REFERRAL_SEARCH_PRESET_VALUES: {
      const { data } = state;
      state = {
        ...state,
        data: {
          ...data,
          presetSearchValues: action.payload
        }
      };
      return state;
    }
    case ReferralsActionTypes.SET_FORWARD_REFERRAL_EXTERNAL_ID: {
      const { data } = state;
      state = {
        ...state,
        data: {
          ...data,
          forwardReferralExternalId: action.payload
        }
      };
      return state;
    }

    case ReferralsActionTypes.SET_FORWARD_REFERRAL_IS_LIST_VIEW: {
      const { data } = state;
      state = {
        ...state,
        data: {
          ...data,
          forwardIsListView: action.payload
        }
      };
      return state;
    }

    case ReferralsActionTypes.CLEAR_ALL_REFERRAL_STATE: {
      return initialState;
    }

    case ReferralsActionTypes.CLEAR_REFERRALS: {
      const { data } = state;
      state = {
        ...state,
        data: {
          ...data,
          referrals: undefined
        }
      };
      return state;
    }

    case ReferralsActionTypes.UPDATE_REFERRAL_RESPONSE: {
      const { data, reprocess } = state;

      state = {
        referralLoader: false,
        data: {
          ...data,
          referral: action.payload
        },
        reprocess
      };

      return state;
    }

    case ReferralsActionTypes.SHOW_REPROCESS_REFERRALS_MODAL: {
      return {
        ...state,
        reprocess: {
          ...state.reprocess,
          modalType: action.payload
        }
      };
    }

    case ReferralsActionTypes.REPROCESS_REFERRALS_START: {
      return {
        ...state,
        reprocess: {
          ...state.reprocess,
          isLoading: true,
          status: 'NONE',
          error: ''
        }
      };
    }

    case ReferralsActionTypes.REPROCESS_REFERRALS_SUCCESS: {
      return {
        ...state,
        reprocess: {
          isLoading: false,
          status: 'SUCCESS',
          error: '',
          modalType: 'NONE'
        }
      };
    }

    case ReferralsActionTypes.REPROCESS_REFERRALS_FAILURE: {
      return {
        ...state,
        reprocess: {
          isLoading: false,
          status: 'FAILURE',
          error: action.payload,
          modalType: 'NONE'
        }
      };
    }

    case ReferralsActionTypes.REPROCESS_REFERRALS_CLEAR: {
      return {
        ...state,
        reprocess: {
          isLoading: false,
          status: 'NONE',
          error: '',
          modalType: 'NONE'
        }
      };
    }

    default:
      return state;
  }
};

export { reducer as ReferralsReducer };
